import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { Button, Notice, Icon} from '@wordpress/components';
import { MediaUpload, URLInput} from '@wordpress/block-editor';
import { upload } from '@wordpress/icons';
import {VayuBlocksCusror} from './cursor-panel';
import { SlideButton } from '@vayu-blocks/global';

export const VayuBlocksCursorPanel = ({cursorValue, onChange, datakey}) => {

    const [errorMessage, setErrorMessage] = useState('');
    
    const handlecustomImage = (value) =>{
        const updatedValue = {
            ...cursorValue,
            customImage:value
        }

        onChange(datakey, updatedValue)
    }

    const  handleToggle = (value) => {
        const updatedValue = {
            ...cursorValue,
            customtype:value
        }

        onChange(datakey, updatedValue);
    }

    const ALLOWED_EXTENSIONS = ['.cur', '.ani', '.png', '.svg', '.gif'];

    const isValidCursorFile = (url) => {
        if (!url || typeof url !== 'string') return false;

        try {
            const pathname = new URL(url).pathname.toLowerCase();
            return ALLOWED_EXTENSIONS.some(ext => pathname.endsWith(ext));
        } catch (e) {
            return false;
        }
    };

    useEffect(() => {
		if (errorMessage) {
			const timeout = setTimeout(() => {
				setErrorMessage('');
			}, 15000); // 15 seconds

			return () => clearTimeout(timeout);
		}
	}, [errorMessage]);

    const handleclearChange = () => {
        const updatedValue = {
            ...cursorValue,
            customImage:''
        }

        onChange(datakey, updatedValue);
    }

  return (

        <>

            <SlideButton  
                button={{ customDefault: "Default", customImage: "Custom" }}
                onChange={(value) => handleToggle(value)}
                defaultValue = {cursorValue?.customtype || 'customDefault'}
            />  

            {cursorValue?.customtype === 'customImage' ? (
                <>
                    <div className='vb-video-input'>
                    <MediaUpload
                        onSelect={(media) => {
                            if (isValidCursorFile(media.url)) {
                                handlecustomImage(media.url);
                                setErrorMessage('');
                            } else {
                                setErrorMessage('Only .cur, .ani, .png, .svg, or .gif files are allowed!');
                            }
                        }}
                        allowedTypes={['image']}
                        render={({ open }) => (
                            <Button
                                onClick={open}
                                icon={<Icon icon={upload} />}
                                label={__('Upload Video', 'vayu-blocks')}
                                style={{
                                    borderRadius: '4px',
                                    padding: '4px',
                                    width: '32px',
                                    height: '32px',
                                    backgroundColor: '#f0f0f0',
                                }}
                            />
                        )}
                    />

                    <URLInput
                        value={cursorValue?.customImage}
                        onChange={(media) => {
                            if (isValidCursorFile(media)) {
                                handlecustomImage(media);
                                setErrorMessage('');
                            } else {
                                setErrorMessage('Only .cur, .ani, .png, .svg, or .gif files are allowed!');
                            }
                        }}
                        placeholder="Enter URL"
                    />
                    </div>

                    {errorMessage && (
                        <Notice status="error" isDismissible={false}>
                            {errorMessage}
                        </Notice>
                    )}

                    {cursorValue?.customImage && (
                        <>
                            <div style={{
                                    marginTop: '10px',
                                    padding: '10px 13px',
                                    justifyContent: 'center',
                                    display: 'flex',
                                    border: '1.5px solid #ccc',
                                    borderRadius: '8px',
                                    backgroundColor: '#f9f9f9'
                                }}
                            >
                                <img
                                    src={cursorValue?.customImage}
                                    alt="Cursor Preview"
                                    style={{ maxWidth: '50px', minWidth:'35px'}}
                                />

                                <button style={{marginTop:'unset'}} className="vayu-button-clear-all-btn" onClick={() => handleclearChange()}>
                                    Clear
                                </button>
                            </div>
                        </>
                    )}
                
                </>
            ):(
                <>
                    <VayuBlocksCusror 
                        cursorValue = {cursorValue} 
                        onChange = {onChange}
                        datakey ={datakey}
                    />
                </>
            )}
            
        </>
  )
}